import React from 'react';

const Paragraph = ({ text = 'Enter your paragraph text here...', align = 'left', size = 'base', className = '' }) => {
  const sizeClasses = {
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
  };

  const alignClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  };

  return (
    <p className={`${sizeClasses[size]} ${alignClasses[align]} text-muted-foreground leading-relaxed ${className}`}>
      {text}
    </p>
  );
};

Paragraph.builderConfig = {
  props: {
    text: {
      type: 'textarea',
      label: 'Paragraph Text',
      default: 'Enter your paragraph text here...',
    },
    align: {
      type: 'select',
      label: 'Text Align',
      default: 'left',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
    size: {
      type: 'select',
      label: 'Text Size',
      default: 'base',
      options: [
        { value: 'sm', label: 'Small' },
        { value: 'base', label: 'Normal' },
        { value: 'lg', label: 'Large' },
        { value: 'xl', label: 'Extra Large' },
      ],
    },
  },
};

export default Paragraph;
